import HeaderWithBackButton from 'app/components/HeaderWithBackButton';
import NewInput from 'app/components/NewInput';
import PageLoader from 'app/components/PageLoader';
import Button from 'app/components/button';
import Dropdown from 'app/components/Dropdown';
import NewAttachment from 'app/components/NewAttachment';
import TextArea from 'app/components/Textarea';
import { APP_CONSTANTS } from 'app/constants/app-constants';
import useCreateNotification from './useCreateNotification';
import DropdownOptions from 'app/utils/DropdownOptions';

const CreateNotification = () => {
  const {
    handleNotificationtypeChange,
    handleTierChange,
    handleMallChange,
    uploadMediaHandler,
    handleChange,
    values,
    error,
    handleCreateNotification,
    pageLoading,
    hideFields,
    mallList,
    campaignList,
    tierMaster,
    notificationId,
    navigate,
  } = useCreateNotification();

  return (
    <div className='blogsForm'>
      <div className='blogsForm_content'>
        <HeaderWithBackButton
          title={` ${
            notificationId ? ' Edit Notification' : 'Create Notification'
          }`}
          goTo={APP_CONSTANTS.NOTIFICATION}
        />
        <div className='inner-form-wrapper flex justify-between flex-wrap mb-4'>
          <div className='wd-50'>
            <Dropdown
              id={'mall_id_temp'}
              label='Mall List*'
              name='mall_id_temp'
              options={mallList}
              placeholder='Select Mall '
              value={values?.mall_id_temp}
              handleChange={handleMallChange}
              isFieldHidden={hideFields}
              errorText={error?.mall_id_temp}
            />
          </div>
          <div className='wd-50'>
            <Dropdown
              id={'tierId'}
              label={`Tier Types ${values?.mall_id_temp === 'All' ? '' : '*'}`}
              name='tierId'
              options={tierMaster}
              placeholder='Select  Tier'
              value={values?.tierId}
              handleChange={handleTierChange}
              isFieldHidden={hideFields}
              errorText={error?.tierId}
              isDisabled={values?.mall_id_temp === 'All' ? true : false}
            />
          </div>
          <div className='wd-50'>
            <Dropdown
              id={'notification_type'}
              label='Notification Types*'
              name='notification_type'
              options={DropdownOptions?.NotificationType}
              placeholder='Select Notification Type'
              value={values.notification_type}
              handleChange={handleNotificationtypeChange}
              isFieldHidden={hideFields}
              errorText={error?.notification_type}
            />
          </div>
          <div className='wd-50'>
            <Dropdown
              id={'campaign'}
              label={`${
                values.notification_type === 'whatsapp'
                  ? 'Campaign List*'
                  : 'Campaign List'
              }`}
              name='campaign'
              options={campaignList ? campaignList : null}
              placeholder='Select Campaign '
              isDisabled={
                values.notification_type === 'whatsapp' ? false : true
              }
              value={values.campaign}
              handleChange={handleChange}
              isFieldHidden={hideFields}
              errorText={error?.campaign}
            />
          </div>
          <div className='wd-50'>
            <Dropdown
              id={'user_type'}
              label='User Types*'
              name='user_type'
              options={DropdownOptions?.NotificationUserType}
              placeholder='Select User Type'
              value={values?.user_type}
              handleChange={handleChange}
              isFieldHidden={hideFields}
              errorText={error?.user_type}
            />
          </div>

          <div className='wd-50'>
            <Dropdown
              id={'gender_type'}
              label='Gender*'
              name='gender_type'
              options={DropdownOptions.Gender}
              placeholder='Select Gender '
              value={values.gender_type}
              handleChange={handleChange}
              isFieldHidden={hideFields}
              errorText={error?.gender_type}
            />
          </div>
          <div className='wd-50'>
            <NewInput
              label='Name*'
              id='name'
              type='text'
              placeholder='Name'
              name='name'
              value={values?.name}
              onChange={handleChange}
              errorText={error?.name}
            />
          </div>
          <div className='wd-50'>
            <NewInput
              label='Title*'
              id='title'
              placeholder='Title'
              name='title'
              value={values?.title}
              errorText={error?.title}
              onChange={handleChange}
            />
          </div>

          <div className='wd-50'>
            <NewInput
              label='Link*'
              id='link'
              placeholder='Link'
              name='link'
              value={values.link}
              errorText={error?.link}
              onChange={handleChange}
            />
          </div>
          <div className='wd-100'>
            <TextArea
              label='Description*'
              id='message'
              type='text'
              placeholder='message'
              name='message'
              value={values?.message}
              onChange={handleChange}
              errorText={error?.message}
            />
          </div>
          <div className='wd-50'>
            <label> Upload Media </label>
            <NewAttachment
              value={values?.media}
              id='media'
              onFileSelected={uploadMediaHandler}
              fileType=''
              label='Choose File'
              className='feed_attachment'
              errorText={error?.media}
              videoAllowed={true}
              customoparentclassName={'bannerparent'}
            />
          </div>
        </div>
        <div className='d-flex justify-content-start'>
          <Button
            className='mt1'
            onClick={handleCreateNotification}
            variant='Save'
            name='Submit'
            isDisabled={pageLoading ? true : false}
          />
          <Button
            className='mt1 cancel-button ms-2'
            onClick={() => navigate(-1)}
            variant='Cancel'
            name='Cancel'
            isDisabled={pageLoading ? true : false}
          />
        </div>
      </div>
      {pageLoading && <PageLoader pageLoading={pageLoading} />}
    </div>
  );
};

export default CreateNotification;
